import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useHttp from "hooks/use-http";

import { Button, Grid } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import TextField from "@mui/material/TextField";
import {
  getticketByIdRequest,
  EditTicketRequest,
  getCloseticketByIdRequest,
} from "api/requests";
import { EditTicketSchema } from "validations";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import BackButton from "components/shared/BackButton";
import DeleteModal from "components/shared/Modal/Delete";
import Toast from "helper/toast";
import FormHelperText from "@mui/material/FormHelperText";
import { IMG_BASE_URL } from "constants";
import { ImUpload } from "react-icons/im";
import { AiOutlineFilePdf } from "react-icons/ai";
import {
  StyledStack,
  StyledTitle,
  TextFieldCustom,
  ButtonContainer,
  StyledTypographyUser,
  StyledTypographyAdmin,
  StyledChoiceFileText,
  StyledUploadBox,
  StyledContainerBox,
} from "./MessageDetails.style";

////////////////////////////
const formList = [
  {
    label: "شرح تیکت",
    type: "text",
    id: "text",
  },
];

export default function MessageDetails() {
  const navigate = useNavigate();
  const params = useParams();
  const { request, loading, setLoading } = useHttp();

  const [ticketmessage, setticketMessage] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [messageInfo, setMessageInfo] = useState({ data: [], count: 0 });
  const [jDate, setJDate] = useState("");

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(EditTicketSchema),
  });
  const [file, setFile] = useState("");

  const onSubmit = async (data) => {
    const res = await request({
      url: EditTicketRequest,
      values: { ...data, ticket_id: params.messageId },
    });
    if (res) {
      reset({
        text: "",
        file: "",
      });
      getMessageInfo();
      Toast({ type: "success", title: "ارسال پیام" });
    }
  };

  const getMessageInfo = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getticketByIdRequest,
      values: params.messageId,
    });
    setLoading(false);

    if (res) {
      if (res.count < 1) {
        return setMessageInfo({
          count: res.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }
      setMessageInfo(res);
      setJDate(res.created_at.jdate);
      setticketMessage(res.ticket_messages);
    }
  }, [request, params.complaintId]);

  useEffect(() => {
    getMessageInfo();
  }, [getMessageInfo]);

  const onClose = async () => {
    const res = await request({
      url: getCloseticketByIdRequest,
      values: params.messageId,
    });

    if (res) {
      setShowDeleteModal(false);
      Toast({ type: "success", title: "بستن تیکت" });
      getMessageInfo();
    }
  };

  return (
    <DrawerCM title="نمایش تیکت">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2}>
            <Grid item mt={3} xs={12}>
              <BackButton />
            </Grid>
            <StyledStack>
              <StyledTitle>نمایش جزئیات تیکت</StyledTitle>
              <Grid container>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextFieldCustom>
                    <span style={{ color: "gray" }}>نام و نام خانوادگی :</span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo?.user?.full_name}
                    </div>
                  </TextFieldCustom>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextFieldCustom>
                    <span style={{ color: "gray" }}> شماره تماس : </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo?.user?.phone_number}
                    </div>
                  </TextFieldCustom>
                </Grid>
                <Grid item md={4} xs={12} p={1.5}>
                  <TextFieldCustom>
                    <span style={{ color: "gray" }}>تاریخ ارسال : </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>{jDate}</div>
                  </TextFieldCustom>
                </Grid>
                <Grid item md={8} xs={12} p={1.5}>
                  <TextFieldCustom>
                    <span style={{ color: "gray" }}>موضوع نظر : </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo.title}
                    </div>
                  </TextFieldCustom>
                </Grid>
                <Grid item xs={12} p={1.5}>
                  {ticketmessage?.map((items, index) => (
                    <div key={index}>
                      {items?.sender_type == "admin" ? (
                        <div style={{ direction: "rtl" }}>
                          <StyledTypographyUser variant="body2">
                            <div>{items?.text}</div>
                            <div style={{ marginTop: "10px" }} className="file">
                              {items?.file == null ? (
                                ""
                              ) : (
                                <>
                                  <a
                                    href={IMG_BASE_URL + items.file}
                                    target="_blank"
                                  >
                                    <AiOutlineFilePdf />
                                  </a>
                                  <span style={{ marginRight: "10px" }}>
                                    <span> فایل ضمیمه </span>
                                    {/* <span> {items.file_size}</span> */}
                                  </span>
                                </>
                              )}
                            </div>
                            <div style={{ marginTop: "10px" }} className="date">
                              {items?.created_at?.jdate}
                            </div>
                            <span className="arrow"></span>
                          </StyledTypographyUser>
                        </div>
                      ) : (
                        <div style={{ direction: "ltr" }}>
                          <StyledTypographyAdmin variant="body2">
                            <div>{items?.text}</div>
                            <div style={{ marginTop: "10px" }} className="file">
                              {items?.file == null ? (
                                ""
                              ) : (
                                <>
                                  <a
                                    href={IMG_BASE_URL + items.file}
                                    target="_blank"
                                  >
                                    <AiOutlineFilePdf />
                                  </a>
                                  <span style={{ marginLeft: "10px" }}>
                                    <span> فایل ضمیمه </span>
                                    {/* <span> {items.file_size}</span> */}
                                  </span>
                                </>
                              )}
                            </div>
                            <div style={{ marginTop: "10px" }} className="date">
                              {items?.created_at?.jdate}
                            </div>
                            <span className="arrow"></span>
                          </StyledTypographyAdmin>
                        </div>
                      )}
                    </div>
                  ))}
                </Grid>
              </Grid>

              {messageInfo?.status == "close" ? (
                ""
              ) : (
                <>
                  <Grid container spacing={1} mt={3}>
                    {formList.map((items, index) => (
                      <Grid
                        item
                        md={12}
                        xs={12}
                        // p={1.5}
                        key={"profile" + index}
                      >
                        <TextField
                          id={items.id}
                          label={items.label}
                          variant="outlined"
                          required={items.required}
                          fullWidth
                          {...register(items.id)}
                          readOnly={items.readOnly}
                          error={Boolean(errors[items.id])}
                          multiline={items.id == "text" ? true : false}
                          rows={items.id == "text" ? 4 : 1}
                        />
                        <FormHelperText id={items.id}>
                          {errors[items.id]?.message}
                        </FormHelperText>
                      </Grid>
                    ))}
                    <Grid item md={12} xs={12}>
                      <Grid item md={12} xs={12}>
                        <StyledContainerBox>
                          <StyledUploadBox>
                            <StyledChoiceFileText>
                              {file ? file : "آپلود فایل ضمیمه"}
                            </StyledChoiceFileText>
                            <ImUpload />
                          </StyledUploadBox>
                          <TextField
                            type="file"
                            variant="outlined"
                            fullWidth
                            id={file}
                            {...register("file")}
                            error={Boolean(errors.file)}
                            helpertext={errors.file?.message}
                            onChange={(e) => setFile(e.target.files[0].name)}
                          />
                        </StyledContainerBox>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      xs={12}
                      style={{ direction: "ltr", paddingTop: "0px" }}
                    >
                      <Button
                        color="success"
                        startIcon={<CheckIcon />}
                        variant="contained"
                        sx={{ mt: 2 }}
                        onClick={handleSubmit(onSubmit)}
                        style={{ direction: "rtl" }}
                      >
                        ارسال پیام
                      </Button>
                      <Button
                        color="error"
                        startIcon={<DeleteIcon />}
                        variant="contained"
                        sx={{ mt: 2, mr: 1 }}
                        onClick={handelShowModal}
                        style={{ direction: "rtl" }}
                      >
                        بستن تیکت
                      </Button>
                    </Grid>
                  </Grid>
                </>
              )}
            </StyledStack>
          </Grid>
          <DeleteModal
            title="آیا از بستن تیکت مطمئن هستید؟"
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={onClose}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
